//export const SERVER_API_URL = 'http://touristapp-backend:3001';
export const SERVER_API_URL = 'https://www.canonegiusto.agenziasocialecasabari.it';
//export const SERVER_API_URL = 'http://agenziasocialecasabari-backend:3001';
